import React from "react";
import InSetBoxShadow from "../../../Common/InSetBoxShadow";

const AfterPeyment = () => {
  return (
    <InSetBoxShadow>
      <div className="row after-payment-step px-4 pb-3">
        <div className="col-12">
          <h3 className="border-bottom py-2 mb-3 mb-md-4">سفارشات شما</h3>
        </div>
        <div className="col-12 ">

          <div className="row px-0 mb-2 mb-md-3 mb-lg-5">

            <div className="col-12 mb-2 mb-md-3">
              <h4>باشگاه نی‌سایا</h4>
            </div>


            <div className="col-12 col-md-6 mb-2 mb-sm-3 d-flex align-items-center">
              <img className="after-payment-icon " src={window.origin + `/WebSide/assets/images/damble.png`} alt="همه باشگاه بدنسازی" />
              <h5 className="h6">بدنسازی ماهانه هرروز</h5>
            </div>

            <div className="col-12 col-sm-6 mb-2 mb-sm-3 col-md-6 d-flex align-items-center">
              <img className="after-payment-icon clock" src={window.origin + `/WebSide/assets/images/404.png`} alt="همه باشگاه بدنسازی" />
              <h5 className="h6">۸ الی ۲۲</h5>
            </div>

            <div className="col-12 col-sm-6 mb-2 mb-sm-3 col-md-6 d-flex align-items-center">
              <img className="after-payment-icon " src={window.origin + `/WebSide/assets/images/counter.png`} alt="همه باشگاه بدنسازی" />
              <h5 className="h6">یک ماه</h5>
            </div>

            <div className="col-12 col-md-6 mb-2 mb-sm-3 d-flex align-items-center">
              <h5 className="h6">ویژه آقایان</h5>
            </div>

          </div>

          <div className="row px-0 border-top pt-2 pt-md-3 pt-lg-5">
            <div className="col-12 col-sm-6 mb-2 mb-sm-3 d-flex align-items-center">
              <img className="after-payment-icon " src={window.origin + `/WebSide/assets/images/50.png`} alt="همه باشگاه بدنسازی" />
              <h5 className="h6">امید رزاعی</h5>
            </div>
            <div className="col-12 col-sm-6 mb-2 mb-sm-3 d-flex align-items-center">
              <img className="after-payment-icon " src={window.origin + `/WebSide/assets/images/scan.png`} alt="همه باشگاه بدنسازی" />
              <h5 className="h6">565464</h5>

            </div>
            <div className="col-12 col-sm-6 mb-2 mb-sm-3 d-flex align-items-center">
              <img className="after-payment-icon " src={window.origin + `/WebSide/assets/images/gender.png`} alt="همه باشگاه بدنسازی" />
              <h5 className="h6">مرد</h5>

            </div>
            <div className="col-12 col-sm-6 mb-2 mb-sm-3 d-flex align-items-center ">
              <img className="after-payment-icon phone" src={window.origin + `/WebSide/assets/images/phone.png`} alt="همه باشگاه بدنسازی" />
              <h5 className="h6">09156598563</h5>
            </div>
          </div>

          <div className="text-center mt-3 mt-md-4">
            <button className="get-ticket" >دریاف بلیت</button>
          </div>

        </div>
      </div>
    </InSetBoxShadow>

  )
};

export default AfterPeyment;
